"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FolderIcon = exports.FileIcon = void 0;
const react_1 = __importDefault(require("react"));
const fi = __importStar(require("./FileIcon.pc"));
const mimetypes = {
    default: fi.Default,
    'text/plain': fi.Word,
    'application/msword': fi.Word,
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': fi.Word,
    'application/vnd.openxmlformats-officedocument.wordprocessingml.template': fi.Word,
    'application/vnd.ms-word.document.macroEnabled.12': fi.Word,
    'application/vnd.ms-word.template.macroEnabled.12': fi.Word,
    'application/vnd.oasis.opendocument.text': fi.Word,
    'application/vnd.google-apps.document': fi.Word,
    'text/csv': fi.Excel,
    'application/vnd.ms-excel': fi.Excel,
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': fi.Excel,
    'application/vnd.openxmlformats-officedocument.spreadsheetml.template': fi.Excel,
    'application/vnd.ms-excel.sheet.macroEnabled.12': fi.Excel,
    'application/vnd.ms-excel.template.macroEnabled.12': fi.Excel,
    'application/vnd.ms-excel.addin.macroEnabled.12': fi.Excel,
    'application/vnd.ms-excel.sheet.binary.macroEnabled.12': fi.Excel,
    'application/vnd.oasis.opendocument.spreadsheet': fi.Excel,
    'application/vnd.google-apps.spreadsheet': fi.Excel,
    'application/vnd.ms-powerpoint': fi.Powerpoint,
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': fi.Powerpoint,
    'application/vnd.openxmlformats-officedocument.presentationml.template': fi.Powerpoint,
    'application/vnd.openxmlformats-officedocument.presentationml.slideshow': fi.Powerpoint,
    'application/vnd.ms-powerpoint.addin.macroEnabled.12': fi.Powerpoint,
    'application/vnd.ms-powerpoint.presentation.macroEnabled.12': fi.Powerpoint,
    'application/vnd.ms-powerpoint.template.macroEnabled.12': fi.Powerpoint,
    'application/vnd.ms-powerpoint.slideshow.macroEnabled.12': fi.Powerpoint,
    'application/vnd.oasis.opendocument.presentation': fi.Powerpoint,
    'application/vnd.google-apps.presentation': fi.Powerpoint,
    'application/pdf': fi.PDF,
    'image/bmp': fi.Picture,
    'image/gif': fi.Picture,
    'image/jpeg': fi.Picture,
    'image/png': fi.Picture,
    'image/svg+xml': fi.Picture,
    'image/webp': fi.Picture,
};
const FileIcon = (_a) => {
    var { mimetype = 'default' } = _a, props = __rest(_a, ["mimetype"]);
    const Icon = mimetype !== null
        ? mimetypes[mimetype] || mimetypes.default
        : mimetypes.default;
    return react_1.default.createElement(Icon, Object.assign({}, props));
};
exports.FileIcon = FileIcon;
const FolderIcon = (_a) => {
    var { size = 24 } = _a, props = __rest(_a, ["size"]);
    return (react_1.default.createElement(fi.FolderIcon, Object.assign({ size: size }, props)));
};
exports.FolderIcon = FolderIcon;
//# sourceMappingURL=FileIcon.js.map